module.exports = __webpack_public_path__ + "3b4bad719774863334c1e7ad6308ac5a.pdf";